import HdlToast from '@/utils/toast';
import { useState, useImperativeHandle, FC, useEffect } from 'react';
import './index.scss';
import { getAliCloudShield } from './util';

interface propsType {
  cRef?: any;
  sendCode: any;
  phone?: number;
}
const SliderModal: FC<propsType> = (props) => {
  const { cRef } = props;
  const [show, setShow] = useState<boolean>(false); //是否展示
  /**
   * @description: 开启
   */
  const open = () => {
    setShow(true);
  };
  /**
   * @description: 关闭
   */
  const close = () => {
    setShow(false);
  };
  // 绑定ref
  useImperativeHandle(cRef, () => ({
    close,
    open,
  }));
  //阿里云盾验证数据
  useEffect(() => {
    if (show) {
      getAliCloudShield((data: any) => {
        if (data.type !== 'error') {
          const params = {
            mobile: props.phone,
            ydSessionId: data.csessionid,
            ydSig: data.sig,
            ydToken: data.nc_token,
            ydScene: 'nc_login_h5',
            type: '',
          };
          props.sendCode && props.sendCode(params);
          setTimeout(() => {
            setShow(false);
          }, 32);
        } else {
          HdlToast.info('验证失败，请重试');
          setTimeout(() => {
            setShow(false);
          }, 32);
        }
      });
    }
  }, [show, props.phone]);
  return show ? (
    <div
      className="mask_"
      onClickCapture={() => {
        setShow(false);
      }}
    >
      <div className="ncMaskBox">
        <img
          src={require('@/images/common/slider.png')}
          className="slider-Img"
          alt="滑块"
        />
        <div className="slide_tip">不小心滑了一下~</div>
        <div id="__nc">
          <div id="nc" />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default SliderModal;
